import { Grid } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import React from 'react';
import moment from 'moment-timezone';
import lodash from 'lodash';

const COLORS = [
  '#7cb5ec',
  '#434348',
  '#90ed7d',
  '#f7a35c',
  '#8085e9',
  '#f15c80',
  '#e4d354',
  '#2b908f',
  '#f45b5b',
  '#91e8e1',
];
const styles = theme => ({
  chart: {
    overflow: 'hidden',
    minWidth: 0,
  },
});

const MemoizedDataChart = withStyles(({
  workstationStats,
  seriesName,
  multipleSeries,
  statName,
  children,
  classes,
  processSeriesName = series => series,
  lg = 3,
  md = 6,
}) => {
  const [memoizedData, setMemoizedData] = React.useState([]);
  const [max, setMax] = React.useState(0);

  const processMultipleSeriesData = data => {
    const dataBySeries = lodash.groupBy(data, datum => datum.series || '-');
    data = Object.keys(dataBySeries).map((series, index) => ({
      color: COLORS[index],
      colorIndex: index,
      name: processSeriesName(series),
      data: dataBySeries[series].map(pair => {
        return [
          moment
            .utc(pair.x)
            .local()
            .valueOf(),
          parseFloat(pair.y),
        ];
      }),
    }));
    return data;
  };

  const processData = (data, id) => {
    setMax(
      Math.max.apply(
        Math,
        data.map(pair => pair.y),
      ),
    );
    return data.map(pair => {
      return [
        moment
          .utc(pair.x)
          .local()
          .valueOf(),
        pair.y,
      ];
    });
  };

  React.useEffect(() => {
    setMemoizedData(
      multipleSeries
        ? processMultipleSeriesData(
            workstationStats.find(stat => stat.name === statName)?.data ||
              null,
          )
        : processData(
            workstationStats.find(stat => stat.name === statName)?.data || [],
            seriesName,
          ),
    );
  }, [workstationStats]);

  return (
    <Grid item sm={12} md={md} lg={lg} className={classes.chart}>
      {children(memoizedData, max)}
    </Grid>
  );
}, styles);

export default MemoizedDataChart;
